import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading || user === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="w-14 h-14 rounded-full bg-gradient-to-br from-[#2563EB] to-[#4F46E5] animate-pulse-glow" />
      </div>
    );
  }
  if (!user) return <Navigate to="/signin" state={{ from: location }} replace />;
  if (roles && !roles.includes(user.role) && user.role !== "admin") {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
